// qr_polynomial - S47.3b.
// Aritmetica de Galois Field GF(256) y Reed-Solomon para QR.
// GF(256) con polinomio primitivo 0x11D (estandar QR/AES).
// Sin libs externas. Tablas log/antilog precomputadas en init.

const GF_LOG = new Array(256);
const GF_EXP = new Array(512);

(function _initGfTables() {
  let x = 1;
  for (let i = 0; i < 255; i += 1) {
    GF_EXP[i] = x;
    GF_LOG[x] = i;
    x <<= 1;
    if (x & 0x100) x ^= 0x11D;
  }
  // Duplicar para evitar % en multiplicaciones.
  for (let i = 255; i < 512; i += 1) GF_EXP[i] = GF_EXP[i - 255];
  GF_LOG[0] = -1;
})();

export function gfMul(a, b) {
  if (a === 0 || b === 0) return 0;
  return GF_EXP[GF_LOG[a] + GF_LOG[b]];
}

// Multiplicacion polinomial en GF(256). p y q son arrays de coeficientes
// (orden: indice 0 = grado mayor).
export function gfPolyMul(p, q) {
  const out = new Array(p.length + q.length - 1);
  for (let i = 0; i < out.length; i += 1) out[i] = 0;
  for (let i = 0; i < p.length; i += 1) {
    for (let j = 0; j < q.length; j += 1) {
      out[i + j] ^= gfMul(p[i], q[j]);
    }
  }
  return out;
}

// Genera el polinomio generador de orden n para Reed-Solomon.
//   g(x) = (x - alpha^0)(x - alpha^1)...(x - alpha^(n-1))
// Devuelve un array de longitud n+1.
export function rsGenPoly(n) {
  let g = [1];
  for (let i = 0; i < n; i += 1) {
    g = gfPolyMul(g, [1, GF_EXP[i]]);
  }
  return g;
}

// Calcula los n codewords de error correction para los `data` codewords
// dados. Implementa la division polinomial estandar Reed-Solomon.
//   data: Array<int 0..255>, length k.
//   n: cantidad de EC codewords (ej. 20 para v4-L).
//   return: Array<int 0..255> length n.
export function rsComputeEC(data, n) {
  const gen = rsGenPoly(n);
  // buf = data + n zeros
  const buf = new Array(data.length + n);
  for (let i = 0; i < data.length; i += 1) buf[i] = data[i] & 0xFF;
  for (let i = data.length; i < buf.length; i += 1) buf[i] = 0;

  for (let i = 0; i < data.length; i += 1) {
    const coef = buf[i];
    if (coef !== 0) {
      const lg = GF_LOG[coef];
      for (let j = 0; j < gen.length; j += 1) {
        const gj = gen[j];
        if (gj === 0) continue;
        buf[i + j] ^= GF_EXP[lg + GF_LOG[gj]];
      }
    }
  }
  // Los ultimos n bytes del buffer son los EC codewords.
  return buf.slice(data.length);
}

// Helper: BCH(15,5) encode para format info QR.
//   data5: 5 bits de datos (level 2 bits + mask 3 bits).
//   return: 15-bit int = 5 data bits + 10 EC bits, sin XOR de mask aun.
export function bchFormat15_5(data5) {
  const G = 0x537; // x^10 + x^8 + x^5 + x^4 + x^2 + x + 1
  let d = (data5 & 0x1F) << 10;
  for (let i = 4; i >= 0; i -= 1) {
    if (((d >> (i + 10)) & 1) === 1) {
      d ^= G << i;
    }
  }
  return ((data5 & 0x1F) << 10) | (d & 0x3FF);
}

// Mascara XOR estandar para format info QR.
export const FORMAT_MASK_15 = 0x5412;
